import { render, staticRenderFns } from "./bank-transfer-sms.vue?vue&type=template&id=2d133882&scoped=true&"
import script from "./bank-transfer-sms.vue?vue&type=script&lang=js&"
export * from "./bank-transfer-sms.vue?vue&type=script&lang=js&"
import style0 from "./bank-transfer-sms.vue?vue&type=style&index=0&id=2d133882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d133882",
  null
  
)

export default component.exports